import LampDinners2024 from '@containers/IQOSUniverse/articles/LampDinners2024/LampDinners2024';

export default LampDinners2024;